import { render } from "./CxPortfolio.vue?vue&type=template&id=0c8788db&scoped=true"
import script from "./CxPortfolio.vue?vue&type=script&lang=js"
export * from "./CxPortfolio.vue?vue&type=script&lang=js"

import "./CxPortfolio.vue?vue&type=style&index=0&id=0c8788db&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c8788db"]])

export default __exports__